import { Bar, BarChart, CartesianGrid, Cell, Legend, ResponsiveContainer, Tooltip, YAxis } from 'recharts';
import { useMemo, useState } from 'react';

import CustomTooltip from './components/customTooltip';
import { LegendContent } from './components/legendContent';
import { UsersStatisticsResDto } from 'types/swagger';
import { useBarChartHooks } from './useBarChartHooks';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';
import { breakpoint } from 'utility/constant';

export interface BarChartComponentProps {
  data?: Array<UsersStatisticsResDto>;
  timeFormatter: Function;
  currPlaytimeFilter: { label: string; value: string };
}

export const BarChartComponent = ({ data, timeFormatter, currPlaytimeFilter }: BarChartComponentProps) => {
  let [posData, setposData] = useState<{ x?: number; y?: number }>({});

  const { chartColors, strokeColor } = useBarChartHooks();
  const { doCheck } = useWindowSize();

  const [isMobile] = doCheck([{ comparer: enComparer.less | enComparer.equal, size: breakpoint.sm }]);

  const minMaxValues = useMemo(
    () =>
      (data &&
        currPlaytimeFilter && [
          Math.min(...data.map((entry) => entry[currPlaytimeFilter.value])),
          Math.max(...data.map((entry) => entry[currPlaytimeFilter.value])),
        ]) ||
      [],
    [currPlaytimeFilter, data]
  );

  return data && currPlaytimeFilter ? (
    <ResponsiveContainer height={300}>
      <BarChart
        data={data}
        margin={isMobile ? { top: 0, right: 0, bottom: 50, left: 0 } : { top: 10, right: 120, bottom: 0, left: 10 }}
      >
        <CartesianGrid vertical={false} stroke="#ccc" strokeDasharray="0 0" />
        <YAxis
          domain={[0, minMaxValues[1] + minMaxValues[1] / 10]}
          ticks={[minMaxValues[0], minMaxValues[1]]}
          tickFormatter={(value) => {
            return currPlaytimeFilter.value === 'importoTot'
              ? value === minMaxValues[0] || value === minMaxValues[1]
                ? value > 99999
                  ? (value / 100000).toFixed(2) + 'K'
                  : (value / 100).toFixed(2)
                : ''
              : timeFormatter(value);
            /* value + ' min'; */
          }}
          style={{
            fontSize: '1rem',
            color: '#ffffff',
            textTransform: 'uppercase',
          }}
        />
        <Tooltip
          cursor={false}
          content={
            <CustomTooltip payload={data} currPlaytimeFilter={currPlaytimeFilter} timeFormatter={timeFormatter} />
          }
          //position={{ x: posData?.x || 0 - 100, y: posData?.y || 0 + 20 }}
          position={{
            x: posData.x && posData?.x - 10,
            y: posData.y && posData?.y - 60,
          }}
        />
        {isMobile ? (
          <Legend layout="horizontal" align="left" content={<LegendContent data={data} />} />
        ) : (
          <Legend layout="vertical" align="right" verticalAlign="middle" content={<LegendContent data={data} />} />
        )}
        <Bar
          dataKey={currPlaytimeFilter.value}
          isAnimationActive={false}
          animationEasing={'ease'}
          onMouseOver={(data) => {
            setposData(data);
          }}
          maxBarSize={70}
        >
          {data?.map((_, index) => (
            <Cell key={`cell-${index}`} fill={chartColors[index]} stroke={strokeColor} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  ) : (
    // TODO : CMS translations
    <p>No data</p>
  );
};
